import script from "./Products-Data-Editor.vue?vue&type=script&setup=true&lang=js"
export * from "./Products-Data-Editor.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__